export default "__VITE_ASSET__CASsSqch__"